
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/courses/[eventId]",
      function () {
        return require("private-next-pages/courses/[eventId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/courses/[eventId]"])
      });
    }
  